// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xHq7","top":"styles_top__37OFt"};